import { lazy } from "react";
import { MODULE_IDS } from "../../constants/enums";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

import { JOBS_APPROVAL_ROUTE, JOBS_ROUTE } from "./jobs.constants";
import { app_navbar_routes } from "../../constants/app-navbar-routes";

// customer
const ManageJobsList = Loadable(
  lazy(() =>
    import("./jobsList").then(({ JobsList }) => ({
      default: JobsList,
    })),
  ),
);

const ManageJobs = Loadable(
  lazy(() =>
    import("./ManageJobs").then(({ ManageJobs }) => ({
      default: ManageJobs,
    })),
  ),
);
const JobApprovalListTable = Loadable(
  lazy(() =>
    import("./JobApprovalListTable").then(({ JobApprovalListTable }) => ({
      default: JobApprovalListTable,
    })),
  ),
);

// customer

export const jobsRoutes = [
  {
    path: JOBS_ROUTE,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.JOBS]}>
        <ManageJobsList />
      </AuthorizedRoute>
    ),
  },
  {
    path: app_navbar_routes.app.approvals.purchase_requesition,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.APPROVAL_JOBS]}>
        <JobApprovalListTable />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${JOBS_ROUTE}/manage`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.JOBS]}>
        <ManageJobs />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${JOBS_ROUTE}/manage/:uuid`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.JOBS]}>
        <ManageJobs />
      </AuthorizedRoute>
    ),
  },
];
